import styled from 'styled-components';
import { darken } from 'polished';

export const Tr = styled.tr`
  &:nth-child(n) {
    text-align: center;
  }
`;

export const Infotable = styled.div`
  position: absolute;
  background-color: #e9ecef;
  margin-left: 10px;
  top: 40.6%;
  display: flex;
  border-radius: 0 0.25rem 0.25rem 0;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  right: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 40px;
  min-height: 46.1px;
  align-content: center;
  justify-content: center;
  align-items: center;
`;

export const HistoryContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  p {
    line-height: 1.5;
    font-size: 0.875rem;
    color: #8898aa;
    white-space: break-spaces;
  }

  span {
    padding: 0.5rem 0;
    font-size: 0.875rem;
    color: #8898aa;
    line-height: 1.5;
  }
`;

export const SelectText = styled.div`
  display: ${(props) => props.hide && 'none'};
  position: absolute;
  background-color: white;
  margin-left: 10px;
  top: 57.1%;
  z-index: 10;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: calc(100% - 6.75rem);
  font-size: 0.875rem;
  font-weight: bold;
`;

export const InputTable = styled.input`
  max-width: 5.5rem;
  border: ${(props) => (props.editable ? '1px solid #dee2e6 ' : 'none')};
  outline: ${(props) => (props.warning ? '1px solid red ' : 'none')};
  animation: ${(props) =>
    props.warning ? 'shake  0.8s ease-in-out; ' : 'none'};

  border-radius: 3px;
  padding: 0 0.3rem;
  color: #525f7f;
  text-align: center;
  background: ${(props) => (props.editable ? 'auto' : 'none')};

  @keyframes shake {
    0% {
      transform: translate(0);
    }
    20%,
    40%,
    60%,
    80% {
      transform: translate(0.3rem);
    }
    10%,
    30%,
    50% {
      transform: translate(-0.2rem);
    }
    70%,
    100% {
      transform: translate(0);
    }
  }
`;

export const CopyButtonWrapper = styled.div`
  background-color: #e9ecef;
  display: flex;
  border-radius: 0 0.25rem 0.25rem 0;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  overflow: hidden;
  width: 40px;
  min-height: 46.1px;
  align-content: center;
  justify-content: center;
  align-items: center;
  transition: background-color 0.25s;
  &&:hover {
    background-color: ${darken(0.2, '#e9ecef')};
  }

  button {
    background: none;
    border: none;
  }
  li {
    background: none;
    border: none;
  }
`;

export const FilialCodeWrapper = styled.div`
  display: flex;
  align-items: center;

  input {
    border-radius: 0.25rem 0 0 0.25rem;
    border-right: none;
  }
`;
